export const getCustomClusterMinMaxPrice = clusters => {
  return clusters[0].combinations.reduce(
    (acc, curr) => {
      const price = curr.cluster.composition_price.total;
      if (price > acc[1]) {
        acc[1] = price;
      }
      if (price < acc[0]) {
        acc[0] = price;
      }
      return acc;
    },
    [
      clusters[0].combinations[0].cluster.composition_price.total,
      clusters[0].combinations[0].cluster.composition_price.total,
    ]
  );
};

export const getClusterMinMaxPrice = clusters => {
  return clusters.reduce(
    (acc, curr) => {
      const price = curr.cluster.composition_price.total;
      if (price > acc[1]) {
        acc[1] = price;
      }
      if (price < acc[0]) {
        acc[0] = price;
      }
      return acc;
    },
    [
      clusters[0].cluster.composition_price.total,
      clusters[0].cluster.composition_price.total,
    ]
  );
};
